import { Component, Input, OnInit } from '@angular/core';
import { CustomerVisitCounts } from 'src/app/core/interfaces/status-counts/customer-visit-counts';
import { LocalStorageService } from 'src/app/core/services/local-storage/local-storage.service';
import { RoleService } from 'src/app/core/services/role/role.service';

@Component({
  selector: 'app-customer-visit-counts',
  templateUrl: './customer-visit-counts.component.html',
  styleUrls: ['./customer-visit-counts.component.scss'],
})
export class CustomerVisitCountsComponent implements OnInit {
  @Input() customerVisitCounts: CustomerVisitCounts;

  currentUserId: string = this.local.get('uid');

  constructor(private role: RoleService, private local: LocalStorageService) {}

  ngOnInit(): void {}

  getUserRole() {
    return this.role.getCurrentUserRole();
  }
}
